import React from "react"
import { AspectRatio, LinkBox, LinkOverlay } from "@chakra-ui/react"

import Link from "@components/Link"
import Image from "@components/Image/Image"
import { TileSizeProps } from "./FeaturedCollections"
import TextButton from "@components/TextButton"

export interface Props {
  item: any
  tileProps: TileSizeProps
  handleTrackingClick: VoidFunction
}

const FeaturedCollectionsItem = ({ item, handleTrackingClick, tileProps }: Props) => (
  <LinkBox mb={3.5} as={`article`} textAlign="left">
    {item?.image && (
      <AspectRatio ratio={tileProps?.ratio}>
        <Image src={item.image} {...tileProps.imageProps} mb={1} />
      </AspectRatio>
    )}
    <LinkOverlay title={item?.title} as={Link} to={item?.link?.url} onClick={handleTrackingClick}>
      <TextButton size={tileProps.buttonSize} icon="chevronRight" marginTop={2}>
        {item?.title}
      </TextButton>
    </LinkOverlay>
  </LinkBox>
)

export default React.memo(FeaturedCollectionsItem)
